import { JWTDecoded } from '@kinde/jwt-decoder';
import { KindeContextProps } from '@kinde-oss/kinde-auth-react';

import { EXTERNAL_ORG_ID_CLAIM } from '@/constants';
import { ConditionNotSatisfied, retryUntil } from '@/utils';

export type ClaimsWithPermissions = JWTDecoded & {
  permissions?: string[];
  user_properties?: { profile_id?: { v: string } };
  [EXTERNAL_ORG_ID_CLAIM]?: string;
};

export const checkHasRequiredClaims = (claims: ClaimsWithPermissions | null): boolean => {
  return !!(
    claims?.[EXTERNAL_ORG_ID_CLAIM] != null &&
    claims?.['permissions']?.length &&
    claims?.['user_properties']?.profile_id?.v != null
  );
};

export const withRequiredClaims = async (auth: KindeContextProps) => {
  try {
    return (await retryUntil({
      fn: auth.getClaims,
      delay: 1500,
      cond: checkHasRequiredClaims,
      numRetries: 5,
    })) as ClaimsWithPermissions | null;
  } catch (error) {
    if (error instanceof ConditionNotSatisfied) {
      return null;
    } else {
      throw error;
    }
  }
};
